// extracted by mini-css-extract-plugin
module.exports = {"PortofolioPage":"PortofolioPage_PortofolioPage__1oLL0"};